import {objToArrK, pickKeys} from "../tools/CommonJS";
import {dispDateTime} from "../tools/CommonHtml";
import {HA_genRemedies, HA_Remedies, HA_topics, misconTopicFlags} from "./MisconData";
import {Benchmark_cisProfilesById, Benchmark_rules, Comp_remedies, xBenchmark_Repo} from "./BenchmarkData";
import {benchmarkLevelOpts, BenchmarkOrg} from "./CommonUIData";

export function xTopic_Repo(topicCode) {
    if (!topicCode) return "";
    const topic = HA_topics[topicCode] || xBenchmark_Repo({topicCode});

    return {
        title: topic.title,
        severity: topic.severity,
        paramTitle: topic.paramTitle,
        unrecognized: topic.unrecognized,
        desc: topic.description?.replace(/<\/?[^>]*\/?[^>]*>/g, "") || topic.desc,
    };
}

export function xGeneric_Repo(actionDatum) {
    if (!actionDatum) return "";
    const repo = HA_genRemedies[actionDatum];
    return repo || {
        title: "Unknown: " + actionDatum + ". Please upgrade the software to the latest version.",
    };
}


export const getRemedyDef = (actionType, actionDatum, topicCode) => {
    switch (actionType) {
        case "remediate":
        case "remediateAuto":
            if (actionDatum === "default_registry_remediation")
                return xTopic_Repo(topicCode);
            return  HA_Remedies[actionDatum] ?? Comp_remedies[actionDatum];
        case "generic":
            return xGeneric_Repo(actionDatum);
        default:
            return undefined;
    }
};


export const statsBarDefs = {
        muted: {h: "Muted", l: "Mute action rule(s) active for target device(s).", border: "border-[#c9b316]",
            tx: "text-[#c9b316]", bg: "bg-[#c9b316]", contrastText: "text-black", c: "#c9b316"},
        approvalPending: {h: "Pending Approval", border: "border-[#e3b4fd]",
            tx: "text-[#e3b4fd]", bg: "bg-[#e3b4fd]", contrastText: "text-black", c: "#e3b4fd"},
        pending: {h: "Pending", l: "task(s) in progress / being applied on target device(s).", border: "border-[#93b4fd]",
            tx: "text-[#93b4fd]", bg: "bg-[#93b4fd]", contrastText: "text-black", c: "#93b4fd"},
        success: {h: "Success", l: "task(s) applied successfully on target device(s).", border: "border-[#01EAC1]",
            tx: "text-[#01EAC1]", bg: "bg-[#01EAC1]", contrastText: "text-white", c: "#01EAC1"},
        reverting: {h: "Reverting", l: "task(s) of revert-remediation in progress / being applied on target device(s).", border: "border-[#666AFF]",
            tx: "text-[#666AFF]", bg: "bg-[#666AFF]", contrastText: "text-white", c: "#666AFF"},
        reverted: {h: "Reverted", l: "task(s) reverted previous remediation on target device(s).", border: "border-[#2C6BF9]",
            tx: "text-[#2C6BF9]", bg: "bg-[#2C6BF9]", contrastText: "text-white", c: "#2C6BF9"},
        cancelled: {h: "Cancelled", l: "task(s) got cancelled before being applied on target device(s).", border: "border-[#7F8593]",
            tx: "text-[#7F8593]", bg: "bg-[#7F8593]", contrastText: "text-white", c: "#7F8593"},
        failed: {h: "Failed", l: "task(s) failed to apply.", border: "border-[#E85893]",
            tx: "text-[#E85893]", bg: "bg-[#E85893]", contrastText: "text-white", c: "#E85893"},
        revertCancelled: {h: "Revert cancelled", l: "revert task(s) got cancelled.", border: "border-[#4C525E]",
            tx: "text-[#4C525E]", bg: "bg-[#4C525E]", contrastText: "text-white", c: "#4C525E"},
        revertFailed: {h: "Revert failed", l: "task(s) failed to revert.", border: "border-[#FF5B61]",
            tx: "text-[#FF5B61]", bg: "bg-[#FF5B61]", contrastText: "text-white", c: "#FF5B61"},
    }, statsBarDefsArr = objToArrK(statsBarDefs);

export const muteStatsBarDefs = {
    ...statsBarDefs,
    success: {h: "Muted", l: "muted successfully on target device(s).", border: "border-[#c9b316]",
        tx: "text-[#c9b316]", bg: "bg-[#c9b316]", contrastText: "text-black", c: "#c9b316"}
};

export const taskStatuses = {
        ...pickKeys(statsBarDefs, ["pending", "success", "reverting", "reverted", "cancelled", "failed", "revertCancelled", "revertFailed"]),
    }, taskStatusesOpts = objToArrK(taskStatuses);

export const activeStateDefs = {
        active: {h: "Active", border: "border-prm-light", bg: "bg-prm-light"},
        reverting: {noOpt: true, h: "Active", border: "border-prm-light", bg: "bg-prm-light"},
        done: {h: "Inactive", border: "border-[#282090]", bg: "bg-[#282090]"},
        approvalPending: {...statsBarDefs.approvalPending, h: "Pending Approval", approval: true},
        approvalRejected: {...statsBarDefs.failed, h: "Aprv. Rejected", approval: true},
        activating: {noOpt: true, h: "Activating: might take a few minutes...", border: "border-prm-light", bg: "bg-prm-light"},
        deactivating: {noOpt: true, h: "Deactivating: might take a few minutes...", border: "border-[#282090]", bg: "bg-[#282090]"},
        approvalTimedout: {noOpt: true, ...statsBarDefs.failed, h: "Approval timed out", approval: true},
    }, activeStateDefsOpts = objToArrK(activeStateDefs);

export const operationLogDefs = {
    create: {h: "Created", c: statsBarDefs.pending.bg},
    activate: {...activeStateDefs.activating, h: "Restarted"},
    deactivate: {...activeStateDefs.deactivating, h: "Stopped"},
    revert: {...activeStateDefs.reverting, h: "Reverted"},
    update: {...statsBarDefs.success, h: "Updated"},
    "revert-task": {...activeStateDefs.reverting, h: "Reverted Task"},
    "remediation-success": {...statsBarDefs.success, h: "Remediation Success"},
    "remediation-failed": {...statsBarDefs.failed, h: "Remediation Failed"},
    "revert-success": {...statsBarDefs.reverted, h: "Revert Success"},
    "revert-failed": {...statsBarDefs.revertFailed, h: "Revert Failed"},
    "revert-cancelled": {...statsBarDefs.cancelled, h: "Revert Cancelled"},
    done: {...activeStateDefs.done, h: "Finished"},
    approvalRejected: {...activeStateDefs.approvalRejected},
    approvalTimedout: {...activeStateDefs.approvalTimedout},
};

export const actionStatsFields = {
    latestActivity:{h: "Last activity", f: v => dispDateTime(v)},
    user: {h: "User"},
    remark: {h: "Action Notes"}
};

export const actionSortDefs = {
        appliedTime: {h: "Applied time"},
        initiatedTime: {h: "Initiated time"},
    }, actionSortOpts = objToArrK(actionSortDefs);

export const actionDefs = {
        "remediate": {h: "Remediate", xc: "#537dee"},
        "muteAlert": {h: "Mute Alert", xc: "#93b4fd"},
        "revert": {h: "Revert", xc: "#0079be"},
        "remediateAuto": {h: "Auto Remediate"},
        "generic": {h: "Generic"}
    }, actionDefsArr = objToArrK(actionDefs);

export const getActionTypeTitle = (data) => {
    const h = actionDefs[data.actionType]?.h;
    return data.actionType.startsWith("remediate") && data.criteria.benchmarkOrg === BenchmarkOrg.appControl
        ? h?.replace("Remediate", "Uninstall") : h;
};

export const actionEdits = {
    stop: {h: "Stop", icon: "delete"},
    revert: {h: "Revert", icon: "undo"},
    restart: {h: "Restart", icon: "loop2"},
};

export const taskRemStatusDefs = {
        "pending": {...statsBarDefs.pending},
        "assigned": {...statsBarDefs.reverting, h: "Assigned"},
        "success": {...statsBarDefs.success},
        "failed": {...statsBarDefs.failed},
        "cancelled": {...statsBarDefs.cancelled},
    }, taskRemStatusDefsArr = objToArrK(taskRemStatusDefs);

export const taskRevertStatusDefs = {
        "pending-revert": {...statsBarDefs.pending},
        "revert-not-done-alert-found": {...statsBarDefs.reverting, h: "Assigned"},
        "verifying-revert": {...statsBarDefs.reverted, altK: "reverted"},
        "failed-revert": {...statsBarDefs.revertFailed, h: "Revert Failed"},
        "revert-cancelled": {...statsBarDefs.revertCancelled, h: "Revert Cancelled"},
    }, taskRevertStatusDefsArr = objToArrK(taskRevertStatusDefs);

export const actionLogSortDefs = {
        "latestActivity": {h: "Latest activity"},
    // "topicTitle": {h: "Attack Vector"},
        "activeTasks": {h: "Active tasks"},
        "totalTasks": {h: "Total tasks"}
    }, actionLogSortOpts = objToArrK(actionLogSortDefs);

export const partialActionDefs = {
        "groupId": {h: "Device Group"},
        "device": {h: "Device Name"},
        "deviceId": {h: "Device Name"},
        "deviceGuid": {h: "Device Name"},
        "computerOu": {h: "Org. Unit"},
        "domain": {h: "Domain"},
        "param": {h: "Attack Vector Instance"},
        "paramExtra": {h: "Attack Vector Instance"},
    }, partialActionFields = Object.keys(partialActionDefs);

export const disableActionMsg = (oSels, disabledActions, isViewOnly) => {
    if (isViewOnly) return "Action cannot be applied: user has only View permissions.";
    if (!oSels.numSelected()) return "Please select at least one item.";
    if (disabledActions.length === oSels.numSelected()) return `Cannot perform operation on selected action.`;
};

export const filterEditableRules = (selectedOperation, oSels) => {
    let excludedObj = {};
    const sels = oSels.getSelection();
    const rulesInfo = oSels.getSelItems().toObj((o, r) => o[r.ruleId] = r);
    const findDone = (id) => ["done", "deactivating"].includes(rulesInfo[id]?.state);
    const getTaskStatuses = (id) => Object.entries(rulesInfo[id]?.taskStatusCounts ?? {}).filter(([_, count]) => !!count);

    const disabledActions = [];

    const assertAction = (operation, filterRuleInfo, filterRule, shouldGrayOutBtn = false) => {
        if (operation === selectedOperation && sels.some(id => filterRule(id))) {
            excludedObj[filterRuleInfo] = sels.filter(id => filterRule(id));
            shouldGrayOutBtn && disabledActions.push(...sels.filter(id => filterRule(id)).map(id => rulesInfo[id]?.actionType));
        }
    };
    assertAction("revert", "Cannot perform operation on Mute actions, use Stop operation instead", (id) => rulesInfo[id]?.actionType === "muteAlert", true);
    assertAction("restart", "Cannot perform operation on Mute actions", (id) => rulesInfo[id]?.actionType === "muteAlert", true);
    assertAction("revert", "Cannot perform operation on Generic actions", (id) => rulesInfo[id]?.actionType === "generic", true);
    assertAction("revert", "Cannot perform operation on failed / cancelled Remediation actions", (id) => getTaskStatuses(id).every(([stat]) => ["cancelled", "failed"].includes(stat)));
    assertAction("revert", "Cannot perform operation on already reverted actions", (id) => getTaskStatuses(id).every(([stat]) => ["reverting", "reverted"].includes(stat)));
    assertAction("stop", "Cannot perform operation on already inactive actions", (id) => findDone(id));
    assertAction("restart", "Cannot perform operation on already active actions", (id) => !findDone(id));

    const filteredExcludedObj = Object.fromEntries(
        Object.entries(excludedObj).filter(([_, arr]) => arr.length > 0)
    );
    const inApplicable = Object.values(filteredExcludedObj).flat();

    return {excludedObj: filteredExcludedObj, disabledActions, ids: sels.filter(id => !inApplicable.includes(id)), rulesInfo};
};

export const filterRevertibleTasks = (oSels) => {
    let excludedObj = {};
    const sels = oSels.getSelection(), tasksInfo = oSels.getSelItems().toObj((o, r) => o[r.taskId] = r);

    if (sels.some(id => !tasksInfo[id]?.revertTime && !["pending", "success"].includes(tasksInfo[id]?.status)))
        excludedObj["Cannot perform Revert on non-successful remediation tasks"] = sels.filter(id => !tasksInfo[id]?.revertTime && !["pending", "success"].includes(tasksInfo[id].status));
    else if (sels.some(id => !tasksInfo[id]?.isRevertable))
        excludedObj["Cannot perform operation on non-revertible tasks"] = sels.filter(id => !tasksInfo[id]?.isRevertable);

    return {excludedObj, ids: sels.filter(id => tasksInfo[id]?.isRevertable), rulesInfo: tasksInfo};
};

export const disableTaskActionMsg = (actionType, oSels, isViewOnly) => {
    if (isViewOnly) return "Action cannot be applied: user has only View permissions.";
    if (!oSels.numSelected()) return "Please select at least one item.";
};

export const getTopicRemedies = (topicCode) => {
    const remedies = Object.values({...HA_Remedies, ...Comp_remedies}).filter(r =>
        Array.isArray(r.topics) ? r.topics.includes(topicCode) :  r.topic === topicCode);
    if (!remedies.length) console.warn(`No remedies found for topicCode: ${topicCode}`);
    return remedies;
};

export const criteriaDefs = {
        device: {h: "Device Name", f: (val) => val},
    // devices: {h: "Device(s)", f: v => v?.length && `${v.slice(0, 2).join(", ")}${v.length <= 2? "" : ` + ${(v.length - 2).toLocaleString()}`}`},
    // listGuids: {h: "Device(s)", f: (val) => val?.length},
        groupId: {h: "Group", f: (val, groups) => groups?.find(g => g.groupId === val)?.groupName},
        domain: {h: "Domain", f: (val) => val === undefined || val === null ? val : (val || "(no domain)")},
        label: {h: "Label", f: (val) => val},
        param: {h: "Instance", f: (val) => val},
        os: {h: "OS", f: (val) => val},
        ip: {h: "IP", f: (val) => val},
        computerOu: {h: "Org. Unit", f: (val) => val},
        osVersions: {h: "OS Version", f: (val) => val?.join(", ")},
        policyName: {h: "Custom CIS Policy", f: (val) => val},
        severities: {h: "Severities", f: (val) => val?.join(", ")},
        flags: {h: "Flags", f: (vals) => vals?.map(val => misconTopicFlags[val]?.h).join(", ")},
        benchmarkProfiles: {h: "CIS Profiles", f: (val) => val?.map(benchmark => Benchmark_cisProfilesById[benchmark]?.title).undup().join(", ")},
        benchmarkProfile: {h: "CIS Level", f: (val) => val && (Benchmark_cisProfilesById[val]?.title || benchmarkLevelOpts.find(level => level.k === val)?.h)},
    }, criteriaDefsArr = objToArrK(criteriaDefs);

export const filterCriteriaDefs = {
        ...criteriaDefs,
        param: {h: "Instance", f: (val) => val, addParams: ["isExactParam", "paramExtra"]}, // isExactParam does not exist in combiDefs.
        computerOu: {h: "Org. Unit", f: (val) => val, addParams: ["isExactComputerOu"]},
        os: {h: "OS", f: (val) => val, addParams: ["isExactOs"]},
        deviceGuid: {h: "Device", f: (val, _, params) => val && (params.device ?? "(1 device)")},
        deviceId: {h: "Device", f: (val, _, params) => val && (params.device ?? "(1 device)")},
    }, filterCriteriaDefsArr = objToArrK(filterCriteriaDefs);

export const taskInfo = {
        domain: {h: "Domain", f: (val) => val === undefined || val === null ? val : (val || "(no domain)")},
        os: {h: "OS", f: (val) => val},
        computerOu: {h: "Org. Unit", f: (val) => val},
    }, taskInfoArr = objToArrK(taskInfo);

export const descActionCriteria = (crit, groups, defsArr = criteriaDefsArr) => [
    ...defsArr.map(def => {
        const val = def.f(crit[def.k], groups, crit);
        return val && `${def.h}: ${val}`;
    }),
    (crit.deviceGuid || crit.deviceId) && !crit.listGuids?.length && !crit.listIds?.length && "1 device",
    getListDesc(crit)
];

const isPatchMngmt = crit => [BenchmarkOrg.appVuln, BenchmarkOrg.osVuln, BenchmarkOrg.appControl].includes(crit.benchmarkOrg);

export const getListDesc =  (crit, showInstances = true) =>
    crit.by && (crit.listGuids?.length || crit.listIds?.length || crit.list?.length ||                      // not SelectAll - devices or params are chosen?
        !(crit.by === "alerts" ? isPatchMngmt(crit) ? crit.product : crit.param : (crit.device || crit.deviceGuid || crit.deviceId))) &&        // if SelectAll and no filter is applied for param or device - don't show "Any Instance / Device"
    getListDescByCrit(crit, isPatchMngmt(crit) ? "application" : xTopic_Repo(crit.topicCode)?.paramTitle, showInstances)?.k;

export function getListDescByCrit({by, isListExclude, list, listGuids, listIds, topicCode, ...restCrit}, paramTitle, showInstances = true) {
    const nObjs = (list?.length ?? 0) + (listGuids?.length ?? 0) + (listIds?.length ?? 0);
    const isAlerts = by === "alerts";
    const type = isAlerts ? "instance" : "device";

    const prefix = !nObjs ? isListExclude ? "Any " : "" : isListExclude ? "All except " : "";
    const count = nObjs ? nObjs.toLocaleString() + " " : "";
    const noun = type.plural(nObjs || 2);   // Plural for "All"/"Any" (nObjs=0), otherwise by count.
    const suffix = isAlerts ? (paramTitle ? ` (${paramTitle})` : topicCode ? isPatchMngmt(restCrit) ? " (application version)" : ` of ${xTopic_Repo(topicCode)?.title}` : "") : "";
    const preview = list?.length && showInstances ? `: ${list.slice(0, 2).join(", ")}${list.length > 2 ? ", ..." : ""}` : "";

    return {h: "By", k: `${prefix}${count}${noun}${suffix}${preview}`};
}

export const actionOptsDefs = [...Object.entries(HA_Remedies), ...Object.entries(Comp_remedies), ...Object.entries(HA_genRemedies)]
    .toObj((o, [k, v]) => o[k] = ({...v, h: v.title, k}));

export const metricOptsDefs = [...Object.entries(HA_topics), ...Object.entries(Benchmark_rules)]
    .toObj((o, [k, v]) => o[k] = ({...v, h: v.title, k}));

export const getActionTitle = (data, addColon = true) => {
    const repo = xTopic_Repo(data.criteria?.topicCode);
    const title = getRemedyDef(data.actionType, data.actionDatum)?.title
        || data.criteria?.ruleName
        || (!repo.unrecognized && repo?.title)
        || (BenchmarkOrg.appControl === data.criteria.benchmarkOrg && data.criteria?.topicCode)
        || ([BenchmarkOrg.appVuln, BenchmarkOrg.osVuln].includes(data.criteria.benchmarkOrg) && data.criteria?.topicCode + (data.criteria.product? " - " + data.criteria.product : ""));
    return title ? addColon ? `: ${title}` : title : "";
};

export const filterModulesDefs = {
        "all": {h: "All sources", exclude: []},
        "miscon": {h: "Misconfig.", exclude: ["benchmark", "app_control", "app_vuln_assessment", "patch_vuln_assessment"]},
        "generic": {h: "Misc. / Generic", exclude: []},
        "benchmark": {h: "Compliance", exclude: ["miscon", "app_control", "app_vuln_assessment", "patch_vuln_assessment"], perms: "benchmark"},
        "vuln_assessment": {h: "Vuln. Assessment", exclude: ["miscon", "app_control", "benchmark"], perms: "vuln_assessment"},
        "app_control": {h: "App Control", exclude: ["miscon", "benchmark", "app_vuln_assessment", "patch_vuln_assessment"], perms: "app_control"},
    }, filterModuleOpts = objToArrK(filterModulesDefs);


export const actionTypes = {
    remediate: {h: "Remediate"},
    remediateAuto: {h: "Auto Remediate"},
    generic: {h: "Generic Action"},
    muteAlert: {h: "Mute Alert"},
    clientUpdate: {h: "Sensor Update"},
};
